/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/10/2023
 */

import { Button, Typography } from "@mui/material";
import React, { useState } from "react";
import styles from "./Categories.module.css";
import { Link } from "react-router-dom";
import { useGetAllTopCategoriesQuery } from "../../Store/Services/CategoryService";

const Categories = ({ id }) => {
  const { data: categories, isSuccess } = useGetAllTopCategoriesQuery();
  const cardCount = categories?.length || 0;

const getCardClass = () => {
  switch (cardCount) {
    case 1:
      return {
        card: styles.cardOne,
        image: styles.imageOne,
        description: styles.descriptionOne,
      };
    case 2:
      return {
        card: styles.cardTwo,
        image: styles.imageTwo,
        description: styles.descriptionTwo,
      };
    case 3:
      return {
        card: styles.cardThree,
        image: styles.imageThree,
        description: styles.descriptionThree,
      };
    case 4:
      return {
        card: styles.cardFour,
        image: styles.imageFour,
        description: styles.descriptionFour,
      };
    case 5:
      return {
        card: styles.cardFive,
        image: styles.imageFive,
        description: styles.descriptionFive,
      };
    default:
      return {
        card: styles.cardFour,
        image: styles.imageFour,
        description: styles.descriptionFour,
      };
  }
};


  const { card, image, description } = getCardClass();

  return (
    <div id={id}>
      <div className={styles.typographyContainer}></div>
      <div className={styles.outerContainer}>
        <div className={styles.container}>
          {isSuccess &&
            categories &&
            Array.isArray(categories) &&
            categories.length > 0 &&
            categories.map((category) => {
              return (
                <Link
                  to={`/checkout/${category.catDisplay
                    .split(` `)
                    .join(`-`)
                    .split(`?`)
                    .join(``)
                    .toLowerCase()}?id=${category.catUuid}`}
                  key={category.catUuid}
                >
                  <div className={card}>
                    <div className={styles.cardItems}>
                      <img
                        className={image}
                        src={
                          `${process.env.REACT_APP_IMAGE_URL}${
                            category.imageList?.split(",")[0]
                          }` ||
                          `${process.env.REACT_APP_IMAGE_URL}E-SERVICE/CATEGORY_IMAGES/home.png`
                        }
                        alt={`image for the category ${category.catDisplay}`}
                        loading="lazy"
                      />
                      <Typography className={styles.label} variant="h1">
                        {category.catDisplay}
                      </Typography>
                      <Typography className={description}>
                        {category.catDesc && category.catDesc.length > 180
                          ? `${category.catDesc.slice(0, 180)}...`
                          : category.catDesc || ""}
                      </Typography>
                      <Button className={styles.button} variant="contained">
                        BOOK NOW
                      </Button>
                    </div>
                  </div>
                </Link>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Categories;
